import styled from "styled-components";
import { Row, Col } from "react-bootstrap";

const Container = styled.div``;

const TabUnderline = (props) => {
  return (
    <Container>
      <Row className="text-center">
        {props.data.map((data, index) => (
          <Col
            className={
              "py-2 tab-underline " +
              (props.selected === `${index}`
                ? "tab-selected"
                : "tab-unselected")
            }
          >
            {data}
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default TabUnderline;
